import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IReportInnerTabResponse, IReportQueryOptions } from '../types';
import { REPORT_INNER_TAB_API_URL, REPORT_INNER_TAB_QUERY } from '../constants';

export default function useReportInnerTabQuery(
  options: Ref<IReportQueryOptions>,
  tabId: Ref<number>,
  innerTabId: Ref<number>,
): IContextQueryResult<IReportInnerTabResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery({
    queryKey: [
      REPORT_INNER_TAB_QUERY,
      options,
      tabId,
      innerTabId,
    ],
    queryFn: ({ signal }) => fetchGet<IReportInnerTabResponse>(REPORT_INNER_TAB_API_URL, {
      signal,
      urlParams: {
        reportType: options.value.reportType,
        widgetType: options.value.widgetType,
        tabId: tabId.value,
        innerTabId: innerTabId.value,
      },
      permission: options.value.permission,
    }),
    enabled: computed(() => !!tabId.value && !!innerTabId.value),
  });
}
